<template>
  <section class="container-full-5">

    <h2 class="secondary-font gap-4 mt-2 mb-4">
      Plan mensuel - {{ periodeLabel }}
    </h2>

    <table v-if="details.length" class="table separator skin2 sm selection">
      <thead>
        <tr>
          <th>Statut</th>
          <th style="width:20%">Mois Revolving</th>
          <th>Décaissement</th>
          <th>Remboursement Revolving</th>
          <th>Revolving Recharge</th>
          <th>Cashback TVA 18%</th>
          <th>Assurance Epargne</th>
          <th>Utilisation Mensuelle</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="detail in details" :key="detail.id" class="text-grey-700">
          <td>
            <div
              class="square px-2 py-2"
              :style="{
                backgroundColor: detail.statut === 'done'
                  ? 'rgb(var(--color-success-rgb), 0.1)'
                  : 'rgb(var(--color-black-rgb), 0.03)'
              }"
            >
              <img
                src="/public/icons/icon-valider.svg"
                width="100%"
                :class="{ 'icon-grey opacity-1': detail.statut !== 'done' }"
              />
            </div>
          </td>
          <td>{{ formatDateFrench(detail.date_prevision) }}</td>
          <td>{{ formatAmount(detail.decaissement || 0) }}</td>
          <td>{{ detail.fond_risque ? '-' + formatAmount(detail.fond_risque) : '0' }}</td>
          <td>{{ formatAmount(detail.recharge || 0) }}</td>
          <td>{{ formatAmount(detail.cashback_tva || 0) }}</td>
          <td>{{ detail.assurance_garantie ? '-' + formatAmount(detail.assurance_garantie) : '0' }}</td>
          <td class="font-bold text-primary-color">{{ formatAmount(detail.utilisation_mois || 0) }}</td>
        </tr>
      </tbody>
    </table>

    <div v-else-if="!loading" class="text-center text-grey-600 py-8">
      Aucun plan mensuel disponible
    </div>

    <div class="clear-both h-60"></div>

  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import profilService, { type Souscription, type SouscriptionDetail } from '@/services/profilService'
import { formatAmount, formatDateFrench } from '@/utils/formatters'

export default defineComponent({
  name: 'PlanMensuel',
  setup() {
    const loading = ref(true)
    const souscription = ref<Souscription | null>(null)

    const details = computed<SouscriptionDetail[]>(() => souscription.value?.details || [])

    const periodeLabel = computed(() => {
      if (!details.value.length) return '-'
      const mois = ['Jan.', 'Fév.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.']
      const first = new Date(details.value[0].date_prevision)
      const last = new Date(details.value[details.value.length - 1].date_prevision)
      return `${mois[first.getMonth()]} ${first.getFullYear()} - ${mois[last.getMonth()]} ${last.getFullYear()}`
    })

    async function loadData() {
      loading.value = true
      try {
        const res = await profilService.getSouscription()
        if (res.data) souscription.value = res.data
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      loadData()
    })

    return {
      loading,
      details,
      periodeLabel,
      formatAmount,
      formatDateFrench
    }
  }
})
</script>
